<template>
  <div class="page-container">
    <div class="query-title">销售计划历史数据查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出历史数据" @click="exportExcel" />
            <el-dropdown @command="downloadTemplate">
              <span class="el-dropdown-link">
                模板下载<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="salePlanSignDataImport">签约量模板</el-dropdown-item>
                <!-- <el-dropdown-item command="breakRuleData">违规数据模板</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <table-button name="import" tip="签约量模板" @click="downloadTemplate('salePlanSignDataImport','签约量模板')" /> -->
            <!-- <table-button name="import" tip="违规数据模板" @click="downloadTemplate('breakRuleData','违规数据模板')" /> -->
            <table-button name="import" tip="导入签约量" @click="handleImportExcel('salePlanSignDataImport','导入签约量')" v-if="showBtn" />
            <!-- <table-button name="import" tip="导入违规数据" @click="handleImportExcel('breakRuleData','导入违规数据')" v-if="showBtn" /> -->
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
            @cell-dblclick="cellClick"
            :span-method="mergeRowMethod"
          >
            <template #oldPlanType="{ row }">
              <span>{{ handlerType(row.newPlanTypeTextView) }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
    <!-- 导入数据确认框 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <vxe-grid
            ref="yTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridDialogOptions.columns"
            :data="gridDialogOptions.data"
            :row-class-name="rowClassName"
          >
          </vxe-grid>
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiExportExcelTemplate,apiExcelImport,apiGetExcelImportData,apiSaveExcelImportData,
  webUploadFile, deleteFiles,queryFiles,saveHanaUploadFile,deleteHanaAttachment,apiFindAttachBizId,apiAttachmentDownFile
} from '@/api/common'
import {findSalePlanHistory, getSignImportLimit} from '@/api/signing'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/salePlanHistory'

import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { generateUUID } from '@/api/flowHander'
import { download } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
export default {
  mixins: [tableMixins],
  data() {
    return {
      showBtn: '',
      conditions: {
        templateCode: '',
        batchNumber: ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
        ],
        columns: [
          // { type: 'checkbox', title: '', width: 50, field: 'checkbox' }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false,
      dialogTitle: '导入数据',
      showDialog: false,
      gridDialogOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            {
              field: 'customerCode',
              title: '客户编号',
              width: 130
            },
            {
              field: 'customerName',
              title: '客户名称',
              width: 130
            },
            {
              field: 'newPlanType',
              title: '计划类型',
              width: 130
            },
            {
              field: 'newPlanTypeName',
              title: '计划类型名称',
              width: 130
            },
            {
              field: 'brand',
              title: '存货分类',
              width: 130
            },
            {
              field: 'brandName',
              title: '存货分类名称',
              width: 130
            },

            // {
            //   field: 'breakRuleQty',
            //   title: '违规数量',
            //   width: 100
            // },{
            //   field: 'omitQty',
            //   title: '历史遗漏数量',
            //   width: 100
            // },
            {
              field: 'signedQty',
              title: '签约数量',
              width: 100
            },
            {
              field: 'remark',
              title: '备注',
              width: 100
            },
          ],
          data: [],
          editConfig: { trigger: 'click', mode: 'cell' }
      },
      breakArr: [
        {
          field: 'customerCode',
          title: '客户编号',
          width: 130
        },
        {
          field: 'customerName',
          title: '客户名称',
          width: 130
        },

        {
          field: 'brand',
          title: '存货分类',
          width: 130
        },
        {
          field: 'brandName',
          title: '存货分类名称',
          width: 130
        },

        {
          field: 'breakRuleQty',
          title: '违规数量',
          width: 130
        },{
          field: 'omitQty',
          title: '历史遗漏数量',
          width: 130
        },
        {
          field: 'remark',
          title: '备注',
          width: 130
        },
      ],
      salePlanArr: [
        {
          field: 'customerCode',
          title: '客户编号',
          width: 100
        },
        {
          field: 'customerName',
          title: '客户名称',
          width: 130
        },
        {
          field: 'newPlanType',
          title: '计划类型',
          width: 130
        },
        {
          field: 'newPlanTypeName',
          title: '计划类型名称',
          width: 130
        },
        {
          field: 'brand',
          title: '存货分类',
          width: 100
        },
        {
          field: 'brandName',
          title: '存货分类名称',
          width: 130
        },
        {
          field: 'signedQty',
          title: '建议签约数量',
          width: 100
        },
        {
          field: 'signedDown',
          title: '建议签约下限',
          width: 100
        },
        {
          field: 'signedUp',
          title: '建议签约上限',
          width: 100
        },
        {
          field: 'remark',
          title: '备注',
          width: 100
        },
        {
          field: 'scanCodeRate',
          title: '跨大区扫码率',
          width: 100
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getSignImportLimit()
    this.initPage(pageConfig)
    this.tableSort.push({ field_name: 'createdDate', field_sort: 'X' })
  },
  methods: {
    async getSignImportLimit(){
      const res = await getSignImportLimit()
      this.showBtn = res.data === '1'
    },
    handlerType(name){
      if(name && name.indexOf('(24)') > -1){
        return name.replace('(24)', '')
      }
      return name
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
      // fields是哪些需要合并的单元格
      const fields = [
        'customerCode',
        'customerName',
        'customerTypeTextView',
        'saleCenterTextView',
        'saleArea'
      ]
      const fields1= [
        'breakRuleQty',
        'omitQty',
        'selledStock',
        'selledQty21',
        'selledQty22',
        'selledQty23',
      ]
      const cellValue = row[column.property]
      if (column.property === 'customerCode' || fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        // 当满足以下条件才去合并上面的单元格
        if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['customerName'] === row['customerName'] && prevRow['customerType'] === row['customerType'] && prevRow['saleCenterTextView'] === row['saleCenterTextView']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['customerName'] === row['customerName'] && nextRow['customerType'] === row['customerType'] && nextRow['saleCenterTextView'] === row['saleCenterTextView']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }else if (row[column.property] && (column.property === 'brandTextView')) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['brandTextView'] === row['brandTextView'] && prevRow['saleCenterTextView'] === row['saleCenterTextView']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['brandTextView'] === row['brandTextView'] && nextRow['saleCenterTextView'] === row['saleCenterTextView']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }else if (row[column.property] && column.property === 'signedQty') {
        // const prevRow = visibleData[_rowIndex - 1]
        // let nextRow = visibleData[_rowIndex + 1]
        // // 当满足以下条件才去合并上面的单元格
        // if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && prevRow['brandTextView'] === row['brandTextView']) {
        //   return { rowspan: 0, colspan: 0 }
        // } else {
        //   let countRowspan = 1
        //   while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['newPlanTypeTextView'] === row['newPlanTypeTextView'] && nextRow['brandTextView'] === row['brandTextView']) {
        //     nextRow = visibleData[++countRowspan + _rowIndex]
        //   }
        //   if (countRowspan > 1) {
        //     return { rowspan: countRowspan, colspan: 1 }
        //   }
        // }
      }else if (row[column.property] && (fields1.includes(column.property) || column.property === 'saleArea')) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        // 当满足以下条件才去合并上面的单元格
        if (prevRow && prevRow['customerCode'] === row['customerCode'] && prevRow['brandTextView'] === row['brandTextView'] && prevRow['saleCenterTextView'] === row['saleCenterTextView']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['customerCode'] === row['customerCode'] && nextRow['brandTextView'] === row['brandTextView'] && nextRow['saleCenterTextView'] === row['saleCenterTextView']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },

    // 模板下载
    async downloadTemplate(type) {
      const fileName = type === 'breakRuleData' ? '违规数据模板' : '签约量模板'
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    // 导入
    handleImportExcel(code,title){
      if(code === 'breakRuleData'){
        this.gridDialogOptions.columns = this.breakArr
      }else{
        this.gridDialogOptions.columns = this.salePlanArr
      }
      this.dialogTitle = title
      this.conditions.templateCode = code
      this.$refs.xTable.refreshColumn()
      // console.log("==dddd=="+JSON.stringify(this.gridOptions.gridOptions.columns))
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const params = { ...this.conditions, page:1, pagesize:9999 }
      const res = await apiGetExcelImportData(params)
      this.gridDialogOptions.data = res.data.Rows
      if(res.data.Rows.length > 0){
        this.showDialog = true
      }
      // this.pagination.totalCount = res.data.Total
    },
    // 导入确认
    async submitHandle() {
      if (!this.gridDialogOptions.data.length) return this.$message.warning('没有可保存的数据！')
      const formData = new FormData()
      const { batchNumber, templateCode } = this.conditions
      formData.append('batchNumber', batchNumber)
      formData.append('templateCode', templateCode)
      const res = await apiSaveExcelImportData(formData)
      if (res.status === 1) {
        this.$message.success('保存成功!')
      }
      this.showDialog = false
    },
    cellClick({ row, rowIndex, column }) {
      // const $table = this.$refs.xTable
      // $table.setCheckboxRow(row, true)
    },
    exportPage() {
      frontExport(this.gridOptions.columns, this.gridOptions.data, '销售计划历史数据')
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        // sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await findSalePlanHistory(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter('xTable', (field, options) => {
          if (field === 'isPcj' || field === 'isShunt') {
            options.forEach(item => {
              if (item.value == '0') {
                item.label = '否'
              } else if (item.value == '1') {
                item.label = '是'
              }
            })
          }
          if (field === 'ajResult') {
            options.forEach(item => {
              if (item.value == 0) {
                item.label = '推送失败'
              } else if (item.value == 1) {
                item.label = '推送成功'
              } else if (item.value == 2) {
                item.label = '推送中'
              }
            })
          }
        })
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length) {
        frontExport(this.gridOptions.columns, checkData, '销售计划历史数据报表')
        return
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        is_result: 1,
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, findSalePlanHistory)
      frontExport(this.gridOptions.columns, data, '销售计划历史数据报表')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  .el-dropdown{
    font-size: 12px;
    padding-left: 10px;
    color: #333;
  }
  /deep/ .el-checkbox{
    .el-checkbox__input {
      display: none
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/qy-manage/salePlanHistory.vue